import React, { createContext, useState } from "react";

// Tedarikçilerle ilgili verileri ve işlemleri paylaşmak için context oluşturuluyor
export const SuppliersContext = createContext();

export const SuppliersProvider = ({ children }) => {
  // Tedarikçiler listesi state'i
  const [suppliersList, setSuppliersList] = useState([
    { id: 1, supplierName: "ABC Tedarik", dealerName: "X Bayi", status: "Aktif" },
    { id: 2, supplierName: "XYZ Tedarik", dealerName: "Y Bayi", status: "Pasif" },
  ]);

  // Yeni tedarikçi ekleme fonksiyonu
  const addSupplier = (supplier) => {
    const newId =
      suppliersList.length > 0 ? Math.max(...suppliersList.map((s) => s.id)) + 1 : 1;
    setSuppliersList((prev) => [...prev, { ...supplier, id: newId }]);
  };

  // Mevcut tedarikçiyi güncelleme fonksiyonu
  const updateSupplier = (id, updatedData) => {
    setSuppliersList((prev) =>
      prev.map((s) => (s.id === id ? { ...s, ...updatedData } : s))
    );
  };

  // Tedarikçi silme fonksiyonu
  const deleteSupplier = (id) => {
    setSuppliersList((prev) => prev.filter((s) => s.id !== id));
  };

  // Provider ile context değerleri paylaşılıyor
  return (
    <SuppliersContext.Provider
      value={{
        suppliersList,   // Tedarikçiler listesi
        addSupplier,     // Tedarikçi ekleme fonksiyonu
        updateSupplier,  // Tedarikçi güncelleme fonksiyonu
        deleteSupplier,  // Tedarikçi silme fonksiyonu
      }}
    >
      {children}  {/* Context'i kullanan tüm bileşenler */}
    </SuppliersContext.Provider>
  );
};
